import { CheckIcon } from "lucide-react"
import { cn } from "@/lib/utils"

interface Step {
  id: number
  title: string
}

interface StepperProps {
  steps: Step[]
  currentStep: number
}

export function Stepper({ steps, currentStep }: StepperProps) {
  return (
    <div className="relative">
      <div className="flex items-center justify-between w-full">
        {steps.map((step) => (
          <div key={step.id} className="flex flex-col items-center">
            <div
              className={cn(
                "flex items-center justify-center w-10 h-10 rounded-full border-2 z-10 bg-background",
                step.id < currentStep
                  ? "border-primary bg-primary text-primary-foreground"
                  : step.id === currentStep
                    ? "border-primary text-primary"
                    : "border-muted text-muted-foreground",
              )}
            >
              {step.id < currentStep ? <CheckIcon className="w-5 h-5" /> : <span>{step.id}</span>}
            </div>
            <span
              className={cn(
                "mt-2 text-xs font-medium text-center",
                step.id <= currentStep ? "text-primary" : "text-muted-foreground",
              )}
            >
              {step.title}
            </span>
          </div>
        ))}
      </div>
      <div className="absolute top-5 left-0 right-0 h-0.5 -translate-y-1/2 bg-muted">
        <div
          className="h-full bg-primary transition-all duration-300"
          style={{
            width: `${((currentStep - 1) / (steps.length - 1)) * 100}%`,
          }}
        />
      </div>
    </div>
  )
}
